import { get } from '../tools/http';
import App from '../main';

export default async function () {
    try {
        const result = await get('vpn-checker', `api/v1/isvpn`, {}, true);
        if (result.isVpn) {
            App.$store.dispatch('addNotify', {
                text: 'Возможно, у вас включен VPN. Для корректной работы платформы рекомендуем вам его отключить.',
                component: 'NotificationApp',
                key: 'vpn-checker',
            });
        }
    } catch (e) {
        console.log(e);
    }
}
